export function secondsToDurationString(t: number | null | undefined): string {
  if(t === null || t === undefined) { return '--:--'; }
  let seconds = Math.round(t);
  const hours = Math.floor(seconds / 3600);
  seconds = seconds - (hours * 3600);
  const minutes = Math.floor(seconds / 60);
  seconds = seconds - (minutes * 60);

  const value = hours > 0 ?
    `${hours}:${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}` :
    `${minutes}:${seconds.toString().padStart(2,'0')}`;

  return value;
}

export function millisecondsToDurationString(t: number | null | undefined): string {
  if(t === null || t === undefined) { return '--:--'; }

  const seconds = Math.round(t / 1000);
  const value = secondsToDurationString(seconds);
  return value;
}